module.exports = __webpack_public_path__ + "img/empresa-logo.4ad17f45.png";